import React from "react";
import { Spinner } from "../Loader/Spinner";

export const LoadableLoader = () => (
    <div className="d-flex align-items-center justify-content-center vh-100">
        <Spinner/>
    </div>
);
